//
// Formatter.js
// commons
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "../moduleBuilder";
import ClosetObject from "../ClosetObject";
import "../lib";

var Formatter = createModule("commons::Formatter", [], ClosetObject, [
    ,
    ,
    ,
    ,
    {
        _format_n: [7,6],
        isNumericFormat: [2],
        isDateFormat: [2],
        getUniqueCompactScales: [[4]],
        getDecimalWidth: [4],
        isDecimalWidthSupported: [2],
        finalizeString: [7,7],
        getWidth: [4],
        parse: [6,7],
        _format_s: [7,7],
        isDateTimeFormat: [2],
        isTimeFormat: [2],
        isUDF: [2],
        getFormatName: [7],
        getMaxFormattedString: [7],
        getMaxFormattedStringLength: [4],
        formatWithoutBidi: [7,6],
        isCharacterFormat: [2],
        getFormatPattern: [7],
    },
    {
        unfinalizeString: [7,7],
    },
    ["format"],
]);
export default Formatter;
